jQuery(function ($) {
    let $items = $('.unique-selling-points__item');

    if ($items.length === 0) return; 

    if ($(window).width() < 767){
        return;
    }


    $(window).on('scroll.uniquesellingpoints', function () {
        $items.each(function (index) {
            const $current = $(this);
            const $next = $items.eq(index + 1);

            // Get bounding rectangles for the current and next items
            const currentRect = $current[0].getBoundingClientRect();

            let scaleFactor = 1; // Default scale is 1 (full size)

            if ($next.length) {
                const nextRect = $next[0].getBoundingClientRect();

                // Calculate overlap with the next item
                const overlap = Math.max(0, currentRect.bottom - nextRect.top);

                if (overlap > 0) {
                    // Apply a less intense scaling effect
                    scaleFactor = Math.max(0.3, 1 - 0.5 * (overlap / currentRect.height));
                }
            }

            // Apply scaling transformation
            $current.css('transform', `scale(${scaleFactor})`);
        });
    });     

    
});
